module.exports = __webpack_public_path__ + "static/media/bar_chart_down.94981e6a.svg";